import React, { createContext, useContext } from 'react';

export interface ShareLinkPermissions {
  sessionId: string;
  transcriptsEnabled: boolean;
  timelineEnabled: boolean;
  rankingEnabled: boolean;
  rankingTtmlAllowed: boolean;
  questionsEnabled?: boolean;
  chatMode: 'DISABLED' | 'READ_ONLY' | 'FULL';
  llmCallCap: number;
  commentsRead: boolean;
  commentsWrite: boolean;
  isPublicShare: boolean;
  narrativeEnabled?: boolean;
  descriptionEnabled?: boolean;
  contextFilesEnabled?: boolean;
  hasNarrativeData?: boolean;
  hasContextFiles?: boolean;
  contextFileCount?: number;
}

export interface ShareLinkMetadata {
  label?: string;
  expiresAt?: string;
  maxViewers?: number;
  currentViewers?: number;
  maxTotalViews?: number;
  totalViews?: number;
}

interface ShareLinkContextType {
  permissions: ShareLinkPermissions | null;
  shareToken: string | null;
  metadata?: ShareLinkMetadata;
}

const ShareLinkContext = createContext<ShareLinkContextType>({
  permissions: null,
  shareToken: null,
  metadata: undefined
});

export const useShareLink = () => useContext(ShareLinkContext);

interface ShareLinkProviderProps {
  children: React.ReactNode;
  permissions?: ShareLinkPermissions;
  shareToken?: string;
  metadata?: ShareLinkMetadata;
}

export const ShareLinkProvider: React.FC<ShareLinkProviderProps> = ({ 
  children, 
  permissions = null, 
  shareToken = null,
  metadata = undefined
}) => {
  return (
    <ShareLinkContext.Provider value={{ permissions, shareToken, metadata }}>
      {children}
    </ShareLinkContext.Provider>
  );
};
